
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetAssociatedAisCamera as ObiTargetAssociatedAisCameraElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-associated-ais-camera.js';
 
 
 

 
 export const ObiTargetAssociatedAisCamera = createComponent({
   react: React,
   tagName: 'obi-target-associated-ais-camera',
   elementClass: ObiTargetAssociatedAisCameraElement,
   events: {
     
   }
  });
 
 